import { useQuery } from '@apollo/client';
import { GET_PAGE_BUILDER_TEMPLATE } from '../apollo/queries';

function useGetAllowedChildChanges(templateId) {
  const { loading, error, data } = useQuery(GET_PAGE_BUILDER_TEMPLATE, {
    variables: {
      id: templateId
    },
    skip: !templateId
  });

  return { loading, error, data, template: data && data.getActivePageBuilderTemplate };
}

export default useGetAllowedChildChanges;
